var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 480,
    x2: 512,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 448,
    x2: 512,
    y2: 448
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 416,
    x2: 512,
    y2: 416
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 384,
    x2: 512,
    y2: 384
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 352,
    x2: 512,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 320,
    x2: 512,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 288,
    x2: 512,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 256,
    x2: 512,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 224,
    x2: 512,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 192,
    x2: 512,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 160,
    x2: 512,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 128,
    x2: 512,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 96,
    x2: 512,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 64,
    x2: 512,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 32,
    x2: 512,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 448,
    y1: 0,
    x2: 448,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 416,
    y1: 0,
    x2: 416,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 384,
    y1: 0,
    x2: 384,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 352,
    y1: 0,
    x2: 352,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 320,
    y1: 0,
    x2: 320,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 288,
    y1: 0,
    x2: 288,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 224,
    y1: 0,
    x2: 224,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 0,
    x2: 192,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 512
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M349.852,343.15c-49.876,49.916-131.083,49.916-181,0c-49.916-49.917-49.916-131.125,0-181.021 c13.209-13.187,29.312-23.25,47.832-29.812c5.834-2.042,12.293-0.562,16.625,3.792c4.376,4.375,5.855,10.833,3.793,16.625 c-12.542,35.375-4,73.666,22.249,99.917c26.209,26.228,64.501,34.75,99.917,22.25c5.792-2.062,12.271-0.583,16.625,3.792 c4.376,4.333,5.834,10.812,3.771,16.625C373.143,313.838,363.06,329.941,349.852,343.15z M191.477,184.754 c-37.438,37.438-37.438,98.354,0,135.771c40,40.021,108.125,36.417,143-8.167c-35.959,2.25-71.375-10.729-97.75-37.084 c-26.375-26.354-39.333-61.771-37.084-97.729C196.769,179.796,194.039,182.192,191.477,184.754z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9b1c8b140e9a389c56c755fd9bb777a6.svg";
export { ForwardRef as ReactComponent };